import React from "react";
import { sizeEqualOrLessThan } from "utils/helpers";

import useScreenSize from "hooks/useScreenSize";
export default function EmbeddedMap(props) {
	if (!props?.data?.data) {
		return <></>;
	}
	const { width, size } = useScreenSize();
	const isSmall = sizeEqualOrLessThan("sm");
	console.log({ isSmall });

	return isSmall ? (
		<iframe
			src={props.data.data}
			width={600 * 0.7}
			height={450 * 0.7}
			style={{
				border: 0,
			}}
			allowFullScreen=""
			loading="lazy"
			referrerPolicy="no-referrer-when-downgrade"
		></iframe>
	) : (
		<iframe
			src={props.data.data}
			width={"600"}
			height={"450"}
			style={{
				border: 0,
			}}
			allowFullScreen=""
			loading="lazy"
			referrerPolicy="no-referrer-when-downgrade"
		></iframe>
	);
}
